import classnames from 'classnames';
import Logout from 'components/Navigation/Logout';
import Survey from 'components/Form/Survey';
import { NavigationToggle } from 'components/Navigation';
import React from 'react';
import i18n from 'util/i18n';

const TITLE_CLASSES: string = classnames('eapp-structure-right', 'eapp-title');

type HeaderBannerProps = {
  mobileNavigation: boolean,
  showSurvey: boolean | undefined,
  submitted: boolean,
}

// TODO: Resolve the conflict between the lint rule and the format on save.
// eslint-disable-next-line func-names
const HeaderBanner = function (props: HeaderBannerProps) {
  const {
    mobileNavigation,
    showSurvey,
    submitted,
  } = props;

  const headingClasses: string = classnames(
    'eapp-structure-wrap',
    'eapp-header',
    {
      'mobile-navigation': mobileNavigation,
    }
  );

  return (
    <div className={headingClasses}>
      <div className="eapp-structure-row">
        <div className="eapp-structure-left eapp-logo" id="logo">
          <NavigationToggle />
          <div className="eapp-logo-container">
            <img
              className="eapp-logo-icon"
              src="/img/dcsa-logo.png"
              alt="National Background Investigation Services"
            />
            <span className="eapp-logo-text">
              {i18n.t('app.logotext')}
            </span>
          </div>
        </div>
        <div className={TITLE_CLASSES}>
          <div className="eapp-logout">
            {showSurvey === true && (
            <Survey className="mobile-hidden" />
            )}
            {!submitted && (
            <a
              href="/instructions"
              target="_blank"
              className="instructions mobile-hidden"
            >
              {i18n.t('app.instructions')}
            </a>
            )}
            {!submitted && (
            <a
              href="/help"
              target="_blank"
            >
              {i18n.t('app.help')}
            </a>
            )}
            <Logout />
          </div>
          {/* Welcome to eApp */}
          {!mobileNavigation && <h1 className="title header-banner-title">{i18n.t('app.title')}</h1>}
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
